<script setup lang="ts">
  import { Select, SelectOption } from 'ant-design-vue'
  import { watch, ref } from 'vue'
  import { useWindowSize } from '@/composables/useWindowSize'

  interface IColumnMultiSelectOrCreateAnalysisConfigConfigurationProps {
    availableColumns: Array<{ value: string; label: string }>
    modelValue: Array<string>
    placeHolder?: string
  }

  const props = defineProps<IColumnMultiSelectOrCreateAnalysisConfigConfigurationProps>()

  const emit = defineEmits<{
    'update:modelValue': [value: Array<string>]
  }>()

  const selectedValue = ref<Array<string>>(props.modelValue)

  watch(
    () => props.modelValue,
    (newVal) => {
      selectedValue.value = newVal
    }
  )

  watch(selectedValue, () => {
    emit('update:modelValue', selectedValue.value)
  })

  const { controlSize } = useWindowSize()
</script>

<template>
  <Select
    mode="tags"
    v-model:value="selectedValue"
    :placeholder="props.placeHolder"
    :size="controlSize"
    class="w-full"
    showSearch
    allowClear
  >
    <SelectOption
      v-for="option in props.availableColumns"
      :key="option.value"
      :value="option.value"
    >
      {{ option.label }}
    </SelectOption>
  </Select>
</template>

<style scoped></style>
